import React from 'react'
import _ from 'lodash'
import './style.css'
import { updateUser } from '~/redux/user/helpers'
import connect from "~/tools/connect";
import userStore from "~/redux/user/store"

class UpdateProfile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    if (this.state.updateSuccess)
      return (
        <div className="change-password centered padded">
          <h2>Your profile has been updated!</h2>
        </div>
      )

    return (
      <div className="edit-profile centered padded">
        <h2>Edit Your Profile</h2>
        <form
          name="updateForm"
          className="update-info-form"
          onSubmit={ e => this.submitForm(e) }>
          <label>Email Address</label>
          <input
            type="email"
            name="email"
            ref={ e => this.emailInput = e }
            placeholder="EMAIL ADDRESS"
            defaultValue={this.state.user && this.state.user.email} required/>
          <label>Name</label>
          <input
            type="text"
            name="name"
            placeholder="NAME"
            ref={ e => this.nameInput = e }
            defaultValue={this.state.user && this.state.user.name} required/>
          
          <label>Your Current Password</label>
          <input
            type="password"
            name="name"
            placeholder="CURRENT PASSWORD"
            ref={ e => this.passwordInput = e }
            required/>
          <br />
          { this.state.error && (<div className="error">{ this.state.error }</div>) }
          <input
            type="submit"
            className={'button cta' + (this.state.processing ? ' processing': '') }
            value="Update"/>
        </form>
      </div>
    )
  }

  submitForm(e) {
    e.preventDefault()

    const data = {
      email: this.emailInput.value,
      name: this.nameInput.value,
      password: this.passwordInput.value,
    }
    this.setState({ processing: true })

    updateUser(data)
      .then((response) => {
        this.setState({ updateSuccess: true })
      }).catch(e =>{
        let errorMsg = _.get(e, 'response.data.error', 'We are unable to update your email.')          
        this.displayError(errorMsg)
      }).then( _ => {
        this.setState({ processing: false })
      })
  }

  displayError(e) {
    this.setState({ error: e })
    setTimeout(_ => this.setState({ error: null }), 5000)
  }  
}

connect(UpdateProfile, (state) => ({ user: state.user }), userStore)

export default UpdateProfile;